import {filter, map} from 'lodash';
import {FormProvider, useForm} from 'react-hook-form';

import FormCombobox from 'components/form/Combobox';
import FormSubmit from 'components/form/Submit';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';


export default function UserTechStackForm({user, techStackOptions, onSave}) {
  const appContext = useAppContext();

  const languageOptions = filter(techStackOptions, (o) => o.category === 'LANGUAGE');
  const frontendOptions = filter(techStackOptions, (o) => o.category === 'FRONTEND');
  const backendOptions = filter(techStackOptions, (o) => o.category === 'BACKEND');
  const databaseOptions = filter(techStackOptions, (o) => o.category === 'DATABASE');
  const devOpsOptions = filter(techStackOptions, (o) => o.category === 'DEVOPS');
  const aiOptions = filter(techStackOptions, (o) => o.category === 'AI');

  const selectedLanguage = filter(user?.techStacks, (ts) => ts.category === 'LANGUAGE');
  const selectedFrontend = filter(user?.techStacks, (ts) => ts.category === 'FRONTEND');
  const selectedBackend = filter(user?.techStacks, (ts) => ts.category === 'BACKEND');
  const selectedDatabase = filter(user?.techStacks, (ts) => ts.category === 'DATABASE');
  const selectedDevOps = filter(user?.techStacks, (ts) => ts.category === 'DEVOPS');
  const selectedAI = filter(user?.techStacks, (ts) => ts.category === 'AI');


  const formMethods = useForm({
    defaultValues: {
      userId: user?.userId,
      language: selectedLanguage?.length > 0
        ? map(selectedLanguage, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      frontend: selectedFrontend?.length > 0
        ? map(selectedFrontend, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      backend: selectedBackend?.length > 0
        ? map(selectedBackend, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      database: selectedDatabase?.length > 0
        ? map(selectedDatabase, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      devOps: selectedDevOps?.length > 0
        ? map(selectedDevOps, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      ai: selectedAI?.length > 0 ? map(selectedAI, (l) => ({label: l.techStackName, value: l.techStackName})) : [],
    },
  });

  const {handleSubmit, setError} = formMethods;

  const onSubmit = async (values) => {
    const techStackNames = [
      ...map(values?.language, (val) => val.value),
      ...map(values?.frontend, (val) => val.value),
      ...map(values?.backend, (val) => val.value),
      ...map(values?.database, (val) => val.value),
      ...map(values?.devOps, (val) => val.value),
      ...map(values?.ai, (val) => val.value),
    ];
    try {
      const rez = await appContext.api.put('api/v1/users/update/techStack', {
        json: {
          userId: values?.userId,
          techStackNames,
        },
        parseJson: true,
      });
      onSave(rez);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h3>Add Tech Stack</h3>
        <FormCombobox
          name="language"
          label="Language"
          isMulti={true}
          options={languageOptions}
          required={true}
        />
        <FormCombobox
          name="frontend"
          label="Frontend"
          isMulti={true}
          options={frontendOptions}
        />
        <FormCombobox
          name="backend"
          label="Backend"
          isMulti={true}
          options={backendOptions}
        />
        <FormCombobox
          name="database"
          label="Database"
          isMulti={true}
          options={databaseOptions}
        />
        <FormCombobox
          name="devOps"
          label="Devops"
          isMulti={true}
          options={devOpsOptions}
        />
        <FormCombobox
          name="ai"
          label="AI"
          isMulti={true}
          options={aiOptions}
        />
        <FormSubmit key="save">Save</FormSubmit>
      </form>
    </FormProvider>
  );
}
